import bankapis  from "../../api/yj";
import vAccount from "../../components/Account.vue";

export default {
    name: "BankList",
    data() {
        return {
            detailVisible:false,
            dataDetail:{},
            userList:[],
            FirstUserIDs:[],
            type:"",
            query: {
                keyword: "",
                state:"",
                pageIndex: 1,
                pageSize: 10
            },
            tableCols:[
                {
                    "prop": "BankID",
                    "label": "银行编号",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "BankName",
                    "label": "银行名称",
                    "width": "",
                    "align": "center"
                },
                {
                    "prop": "State",
                    "label": "状态",
                    "width": "100",
                    "align": "center"
                },
                {
                  "prop": "UserName",
                  "label": "终审人员",
                  "width": "140",
                  "align": "center"
                },
                {
                    "prop": "CreateTime",
                    "label": "创建时间",
                    "width": "160",
                    "align": "center"
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "300",
                    "align": "center"
                }
            ],
            tableData:[],
            pageTotal: 0,
            scrollHeight:400,
            tel:"",
            accountVisible:false,
            bankId:"0",
        };
    },
     components: { vAccount},
    created() {
      this.getData();
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    // watch: {
    //   dataDetail: {
    //     handler(newVal) {
    //       this.tel=newVal.UserID
    //       var userList=this.userList;
    //       for(var i=0;i<userList.length;i++)
    //       if(userList[i].UserID==newVal.UserID){
    //         var tel=userList[i].Tel;
    //         this.tel=tel;
    //       }
    //      },
    //      deep: true,
    //   }
    // },
    methods: {
        getData(){
          let param=this.query;
          bankapis.getBankList(param).then(res => {
                            this.$data.tableData=res.list;
                            this.$data.pageTotal=res.count
                    });
    
      },
              handleAccount(val) {
                this.bankId=val;
            this.accountVisible = true;
        },
        getAccount(val) {
            this.accountVisible = false;
            if(val){
                
            }
        },

      getBankById(){
          let param={
            bankId: "1"
          };
         bankapis.getYjBankById(param).then(res => {
                            this.$data.form=res;
                    });
      },
      addOrUpdateBank(){
          let param=this.$data.dataDetail;
          if(param.BankName==""){
            this.$message.error("名称不能为空");
            return;
          }
          if(param.State=="2"){
            if(param.FDDCode==""){
              this.$message.error("营业执照号不能为空");
              return;
            }
            if(this.FirstUserIDs.length==0){
              this.$message.error("初审不能为空");
              return;
            }
            if(param.ActUserName==""){
              this.$message.error("经办人姓名不能为空");
              return;
            }
            if(param.ActFddCode==""){
              this.$message.error("经办人法大大号不能为空");
              return;
            }
            if(param.BankFDDCode==""){
              this.$message.error("银行法大大号不能为空");
              return;
            }
            if(param.SecondUserID==""){
              this.$message.error("复审不能为空");
              return;
            }
            if(param.ThirdUserID==""){
              this.$message.error("终审不能为空");
              return;
            }
          }
          param.FirstUserIDs=this.FirstUserIDs.join(",");
          if(this.type=="add")this.addBank(param);
          else{
             param.Id=this.dataDetail.BankID;
            this.updateBank(param);
          } 
      
      },
      addBank(param){
        bankapis.addBank(param).then(res => {
          if(res){
           this.$message.success("新增成功");
             this.getData();
             this.$data.detailVisible=false;
          }else {
            this.$message.error("新增失败");
          }
      });
      },
       updateBank(param){
         bankapis.updateBank(param).then(res => {
                        if(res){
                         this.$message.success("修改成功");
                           this.getData();
                           this.$data.detailVisible=false;
                        }else{
                          this.$message.error("修改失败");
                        }
                    });
      },
        // 触发搜索按钮
        refreshList() {
            this.query.pageIndex = 1;
            this.getData();
        },
        getYJUserList(yjId){
          let param={
            type:"120",
            yjId:yjId,
            keyword:""
          }
          bankapis.getYjUserListByMenuId(param).then(res => {
            for(var i=0;i<res.length;i++){
              if(res[i].Tel)res[i].UserName+=res[i].Tel;
              res[i].UserID=res[i].UserID+"";
            }
            this.userList=res;
        });
        },
        handleEmpty(){
           this.$data.query={
            keyword: "",
            state:"",
            pageIndex: 1,
            pageSize: 10}
        },
        handleAdd(){
          this.getYJUserList();
          this.$data.detailVisible=true;
          this.dataDetail={
            BankName:"",
            FDDCode:"",
            SecondUserID:"",
            ThirdUserID:"",
            State:"1",
            IsFreeSign:"0",
          }
          this.FirstUserIDs=[];
          this.type="add";
        },
        handleUpdate(index, row){
          this.FirstUserIDs=[]
          if(row.FirstUserIDs)this.FirstUserIDs=row.FirstUserIDs.split(",");
          this.getYJUserList(row.BankID);
          this.dataDetail={
            BankID:row.BankID,
            BankName:row.BankName,
            FDDCode:row.FDDCode,
            SecondUserID:row.SecondUserID,
            ThirdUserID:row.ThirdUserID,
            State:row.State+"",
            IsFreeSign:row.IsFreeSign+"",
             NBYHZH:row.NBYHZH,
               NBZHKHH:row.NBZHKHH,
                NBZHHM:row.NBZHHM,
              SYFL:row.SYFL,
              YQFL:row.YQFL,
              WYFL:row.WYFL,
              ZDZHZH:row.ZDZHZH,
               ZDZHKHH:row.ZDZHKHH,
                ZDZHHM:row.ZDZHHM,
                WorkDayNum:row.WorkDayNum,
                ZDYYBHH:row.ZDYYBHH,
                ActFddCode:row.ActFddCode,
                ActUserName:row.ActUserName,
                BankFDDCode:row.BankFDDCode
          }
          this.type="update";
          this.$data.detailVisible=true;
        },
        // 删除操作
        handleDelete(index, row) {
           let that = this;
            if(row){
                that.$confirm('确定删除吗, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                  let param={
                    Id:row.BankID
                  };
                 bankapis.deleteBank(param).then(res => {
                                if(res){
                                  that.$message.success("删除成功");
                                  that.getData();
                                }else{
                                  that.$message.error("删除失败");
                                }
                            });
                }).catch(() => {
                  that.$message({
                      type: 'info',
                      message: '已取消删除'
                    });
                });
            }
        },
        // 分页导航
        handlePageChange(val) {
            this.query.pageIndex = val;
            this.getData();
        },
        handleSizeChange(val){
            this.query.pageIndex = 1;
            this.query.pageSize = val;
            this.getData();
        },
        calcTableHeight(){
          this.$nextTick(() => {
            var height1=$(".content-box .content").height();
            var height2=$(".content-box .content .seach-container").height();
            var height=height1-height2-112-40;
            this.scrollHeight = height;
          });
        }
    },
  
  };
